import React, { useEffect } from "react";
import Header from "../Header";
import Footer from "../Footer";
import PageBanner from "../PageBanner";
import Faq from "../Policy/Faq";
import MetaTags from "react-meta-tags";

const FaqPage = () => {
  const Breadcrumb = [
    {
      title: "Domov",
    },
    {
      title: "Najčastejšie otázky",
    },
  ];
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  });

  return (
    <>
      <MetaTags>
        <title>Sedačka na každodenné spanie s úložným priestorom</title>
        <meta name="description" content="Sedačka na každodenné spanie s úložným priestorom, moderným dizajnom a vysokým komfortom. Praktické riešenie pre kvalitný spánok a organizovaný priestor." />
        <meta property="og:title" content="Sedačka na každodenné spanie s úložným priestorom" />
        <meta property="og:image" content="assets/Images/emma4.jpg" />
      </MetaTags>
      <Header />
      <PageBanner value={Breadcrumb} />
      <Faq />
      <Footer />
    </>
  );
};

export default FaqPage;
